import React from 'react';
import logo from "../../images/logo/logo-full-black.png";
import { Button, Divider } from 'semantic-ui-react';
import mailImage from "../../images/grafix-banner/gfx-account-success.svg";
import gfxContactImage from "../../images/grafix-banner/gfx-contact.svg";
import gfxHackerImage from "../../images/grafix-banner/gfx-hacker.svg"
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import queryString from 'query-string';
import LoadingComponent from "./../common/LoadingComponent";
import './styles.css';
import ModalHeader from './../drive/ModalHeader';
import ModalFooter from './../drive/ModalFooter';
import accountImage from '../../images/grafix-banner/gfx-user-account.svg';
import CopyrightFooter from '../drive/CopyrightFooter';
class OrderSuccessPage extends React.Component {

    constructor(props) {
        super(props);
        this.gotToLogin = this.gotToLogin.bind(this)
    }

    componentDidMount() {
        const queryStringData = queryString.parse(this.props.location.search);
        // dispatch.registerAccount.registerAccountAsync(queryStringData);
    }

    gotToLogin() {
        const { history } = this.props;
        history.push('/login');
    }

    render() {

        let error = {}
        let couldntFindMail = <p className="f_10"><strong>Couldn't find e-mail? </strong><p>If you didn't see it, check Spam folder. <br /> Try searching the email with <strong>no-reply@aspenify.com</strong></p></p>
        let loginButton = <Button onClick={this.gotToLogin} className="button-submit" id="submit">Login</Button>
        // if (this.props.registrationError === 'Subscription does not exists' || this.props.registrationError === 'Customer does not exists') {
        //     error.name = "Something's wrong"
        //     error.image = gfxHackerImage
        //     error.subHeader1 = "Invalid URL"
        //     error.colorClass = "clr-orange"
        //     error.subHeader2 = <p>Looks like you tried accessing a page that does not exists. <br /> If you accidentaly came here, go back to <a href="http://aspenify.com/" className="clr-blue"> aspenify.com </a></p>
        // } else if (this.props.registrationError === 'Error while creating account user') {
        //     error.name = "An error has occured while generating your login details"
        //     error.image = gfxContactImage
        //     error.subHeader1 = "Contact Us"
        //     error.colorClass = "clr-orange"
        //     error.subHeader2 = <p>We keep track of errors and will let you know what went wrong.
        //     <br /> Contact us to get your login details.
        //     <br /> E-Mail:<a href="mailto:support@aspenify.com" target="_blank"> support@aspenify.com</a>
        //     </p>
        // } else if (this.props.registrationError === 'Email already exists') {
        //     error.name = "You do not need to reload the page/URL"
        //     error.image = mailImage
        //     error.subHeader1 = "Account already created"
        //     error.colorClass = "clr-green"
        //     error.subHeader2 = <p>The account has already been created.<br /> Please check your e-mail for login details.</p>
        //     error.footer = couldntFindMail;
        // }
        // else if (this.props.registrationError === 'Success') {
            error.name = "Thanks for creating Aspenify account"
            error.image = mailImage
            error.subHeader1 = "Check your email"
            error.colorClass = "clr-green"
            error.subHeader2 = <p>We have sent your login details on <br /> {this.props.emailId}</p>
            error.login = loginButton
            error.footer = couldntFindMail;
        // }
        // else if (this.props.registrationError === 'New Account Created For Existsing User') {
        //     error.name = " "
        //     error.image = accountImage
        //     error.subHeader1 = "Your account has been created successfully"
        //     error.colorClass = "clr-green"
        //     error.subHeader2 = <p>You can user your current credentials to login.</p>
        //     error.login = loginButton
        // }
        // else if (this.props.registrationError && this.props.registrationError.includes('already has an account in the system')) {
        //     error.name = this.props.registrationError;
        //     error.image = gfxContactImage
        //     error.subHeader1 = "Contact Us"
        //     error.colorClass = "clr-orange"
        //     error.subHeader2 = <p>We keep track of errors and will let you know what went wrong.
        //     <br /> Contact us to get your login details.
        //     <br /> E-Mail:<a href="mailto:support@aspenify.com" target="_blank"> support@aspenify.com</a>
        //     </p>
        // }
        // else {
        //     error.name = "An error has occured while generating your login details"
        //     error.image = gfxContactImage
        //     error.subHeader1 = "Contact Us"
        //     error.colorClass = "clr-orange"
        //     error.subHeader2 = <p>We keep track of errors and will let you know what went wrong.
        //     <br /> Contact us to get your login details.
        //     <br /> E-Mail:<a href="mailto:support@aspenify.com" target="_blank"> support@aspenify.com</a>
        //     </p>
        // }

        return (
            <div className="outer">
                <div className="middle bg-banner">
                    {this.props.regisetrUserLoader ?
                        <LoadingComponent active={this.props.regisetrUserLoader} message="Setting up your account" />
                        :
                        <div className="inner">
                            <ModalHeader
                                header={<img src={`${logo}`} alt='' />}
                                subHeader={this.props.firstName ? "Hello " + this.props.firstName : ""} />
                            <div className="ModalContent">
                                <p className="error_text1">{error.name}</p>
                                <div ><img src={error.image} height="160" alt='' /> </div>
                                <div className={` error_text2 ${error.colorClass}`}>{error.subHeader1}</div><br />
                                <span className="error_text3">{error.subHeader2}</span><br />
                                <span>{error.login}</span>
                            </div>
                            <Divider className="mar_0" />
                            <ModalFooter text={error.footer ? error.footer : <CopyrightFooter />} />
                        </div>
                    }

                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { registered, registrationError, emailId, firstName, lastname } = state.registerAccount;
    return {
        registered, registrationError, emailId, firstName, lastname,
        regisetrUserLoader: state.loading.effects.registerAccount.registerAccountAsync
    };
}

const connectedOrderSuccessPage = connect(mapStateToProps)(OrderSuccessPage);
export { connectedOrderSuccessPage as OrderSuccessPage };
